module.exports = __webpack_public_path__ + "media/application/images/paradigm-bg-960977f95389a885212f24bf6b4f569e.jpg";